<template>
  <div class="mega-nav-column">
    <span v-if="title.value" aria-hidden="true" class="mega-nav-column__heading font-s">
      {{ title.value }}
    </span>
    <span :id="`column-${columnIndex}-sr-label`" class="sr-only">
      {{ `Navigation column ${columnIndex + 1} of ${numOfColumns} ${title.value || ''}` }}
    </span>
    <ul class="mega-nav-column__container" :aria-labelledby="`column-${columnIndex}-sr-label`">
      <li v-for="(item, index) of subItems" :key="index" class="mega-nav-column__item">
        <nav-item
          v-bind="item.fields"
          :item-type="navItemsType"
          :data-test-id="`mega-nav-item-${index}`"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import NavItem from '../../NavItem/NavItem.vue';
import type { SitecoreField } from '@/types';
import type { NavSubItem, NavItemType } from '../../types';

interface MegaNavColumnProps {
  title?: SitecoreField<string>;
  subItems?: NavSubItem[];
  navItemsType?: NavItemType;
  columnIndex?: number;
  numOfColumns?: number;
}

withDefaults(defineProps<MegaNavColumnProps>(), {
  title: () => ({}) as SitecoreField<string>,
  subItems: () => [],
  navItemsType: 'text-only',
});
</script>

<style lang="scss">
@import './scss/MegaNavColumn.scss';
</style>
